import { Button } from "@mui/material";
import React from "react";
import DivisionCardCmp from "../../components/cards/divisionCardCmp";
import DivisionCardUserCmp from "../../components/cards/divisionCardUserCmp";
import DivisionCardFacilityCmp from "../../components/cards/divisionCardFacilityCmp";
import Grid from "@mui/material/Grid";
import { ModalActivationCode } from "../../components/modals/ModalActivationCode";
import { DivisioncaredContentComponent } from "../../components/cards/divisionCardContentComponent";
import { useMutation, useQueryClient } from "react-query";
import {
  LoanTemplateInfo,
  CustomerInfo,
  ReferenceKeyRequest,
  ExistingLoanRequest,
} from "../../models/loan.model";
import {
  LOAN_ID,
  LOAN_TEMPLATE_INFOS,
  CUSTOMER_INFO,
  REFERENCE_KEY,
  INSTALLMENT_COUNT,
  INSTALLMENT_STEP,
  EXISTING_LOANREQUEST,
  Timer_INIT,
} from "../../config/cacheKey";
import { HandleNext } from "../../models/sharedFunctions";
import { sendLoanActivationCodeToCustomer } from "../../services/loan.service";

function _DivisionCardContentCmp() {
  return (
    <DivisioncaredContentComponent />
    // <DivisioncaredContentComponent value={value} />
  );
}

const value = [
  { title: "سقف قابل اعطا:", data: "54654613 ریال" },
  { title: "مهلت استفاده از تسهیلات:", data: "10.02.1399" },
  { title: "تاریخ تولید:", data: "امروز" },
];

export default function FacilityApproval({ handleNext }: HandleNext) {
  const [submitFlag, setSubmitFlag] = React.useState<boolean>(true);

  React.useEffect(() => {
    const keyPressEvent = (e: any) => {
      if (e.key === "Enter") {
        handelVerify();
      }
    };
    window.addEventListener("keydown", keyPressEvent);
    return () => {
      window.removeEventListener("keydown", keyPressEvent);
    };
  }, []);

  // const [openModal, setOpenModal] = React.useState(false);
  // function showActivationCodeModal() {
  //   setOpenModal(true);
  // }
  const queryClient = useQueryClient();
  const installmentCount = queryClient.getQueryData<string>(INSTALLMENT_COUNT);
  const existingLoanRequest = queryClient.getQueryData<ExistingLoanRequest>(
    EXISTING_LOANREQUEST
  );

  const installmentStep = queryClient.getQueryData<string>(INSTALLMENT_STEP);
  const loanInfo = queryClient.getQueryData<LoanTemplateInfo[]>(
    LOAN_TEMPLATE_INFOS
  );
  const customerInfo = queryClient.getQueryData<CustomerInfo[]>(CUSTOMER_INFO);
  const loan_id = queryClient.getQueryData(LOAN_ID);
  const listloan = loanInfo
    ?.filter((item: any) => item.id == loan_id)
    .map((item: any, index: number, array: any) => {
      return {
        title: item.title,
        cardImage: item.cardImage,
        id: item.id,
        maxAmount: item.maxAmount,
        profitPercentage: item.profitPercentage,
        expirationDate_Persian: item.expirationDate_Persian,
        financialSupplierTitle: item.financialSupplierTitle,
      };
    });
  const facilitylistloan = loanInfo
    ?.filter((item: any) => item.id == loan_id)
    .map((item: any, index: number, array: any) => {
      return {
        maxAmount: item.maxAmount,
        stepSpaceByMonth: installmentStep,
        id: item.id,
        installmentCount: installmentCount,
        installmentStep: item.installmentStep,
      };
    });
  const sendLoanActivationCodeToCustomerMutation = useMutation(
    sendLoanActivationCodeToCustomer,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          handleNext();
          queryClient.setQueryData(Timer_INIT, true);
        } else {
          setSubmitFlag(true);
        }
      },
      onError: () => {
        setSubmitFlag(true);
      },
    }
  );

  const handelVerify = () => {
    if (submitFlag) {
      setSubmitFlag(false);
      const referenceKey = new ReferenceKeyRequest();
      referenceKey.referenceKey = queryClient.getQueryData(REFERENCE_KEY);
      sendLoanActivationCodeToCustomerMutation.mutate(referenceKey);
    }
  };

  const child = <_DivisionCardContentCmp />;
  return (
    <div>
      <DivisionCardCmp
        title="طرح رز"
        value={listloan}
        titleCard="مشخصات طرح انتخاب شده:"
      />
      <DivisionCardUserCmp
        title="طرح رز"
        value={customerInfo}
        titleCard="مشخصات کاربر:"
      />
      <DivisionCardFacilityCmp
        title="طرح رز"
        existingLoanRequest={existingLoanRequest?.finalLoanAmount}
        value={facilitylistloan}
        titleCard="مشخصات تسهیلات :"
      />
      <div
        className="cardBorder borderCOlor mTop20"
        style={{ margin: "0px 10px 0px 10px" }}
      >
        <p
          style={{
            fontSize: "16px",
            textAlign: "center",
            marginTop: "20px",
            marginBottom: "36px",
          }}
        >
          در صورت صحیح بودن اطلاعات، با انتخاب گزینه{" "}
          <span style={{ fontSize: "16px", fontWeight: "bold" }}>
            "تایید اطلاعات و ارسال کد فعالسازی"
          </span>
          پیامک حاوی کد فعالسازی تسهیلات، برای متقاضی ارسال خواهد شد.
        </p>
        <div style={{ textAlign: "center", marginBottom: "40px" }}>
          {/* <ModalActivationCode openModal={false} /> */}

          <Button
            type="submit"
            variant="contained"
            className="btnForm SuccessDefault Vazirmatn "
            onClick={handelVerify}
          >
            تایید اطلاعات و ارسال کد فعالسازی
          </Button>
        </div>
      </div>
    </div>
  );
}
